import { List } from "@mui/material";

import type { UploadRootProps } from "./types";

export function UploadRoot({ children, sx }: UploadRootProps) {
  return (
    <List
      sx={{
        backgroundColor: "#E7E6F7",
        borderRadius: 2,
        flex: 1,
        p: 1,
        "& .MuiListItem-root": {
          mb: 2,
        },
        ...sx,
      }}
    >
      {children}
    </List>
  );
}
